<template>
  <div :class="$style.content">
    <h1>{{ title }}</h1>
    <div v-html="content" />
  </div>
</template>

<script>
export default {
  async asyncData({ redirect, app, params, $winstonLog }) {
    if (!/^\d+$/.test(params.id)) {
      return redirect('/statement')
    }

    // 法律协议详情
    try {
      const { data } = await app.$axios.post('/wbhome/lawsDetail', {
        id: params.id,
      })
      if (data.rcode === 0) {
        return {
          title: data.data.title || '',
          content: data.data.content || '',
        }
      } else {
        return redirect('/statement')
      }
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
      return redirect('/statement')
    }
  },
  head() {
    return {
      title: this.title,
    }
  },
}
</script>

<style lang="less" module>
.content {
  margin: 0 3.6rem;
  padding: @padding-base-title 0;
  line-height: 1.8;

  @media screen and (max-width: @tablet-width) {
    margin: 0 2rem;
  }

  @media screen and (max-width: @mini-width) {
    margin: 0 1rem;
  }

  h1 {
    margin-bottom: @padding-title-bot;
    font-size: 18px;
  }
}
</style>
